var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-error-warp"},[_c('img',{staticClass:"network-error-img",attrs:{"src":_vm.img}}),_c('div',{staticClass:"network-error-text"},[_vm._v("加载失败，请点击刷新后重试")]),_c('label',{staticClass:"network-error-label",on:{"click":_vm.refresh}},[_vm._v("刷新")])])
}
var staticRenderFns = []

export { render, staticRenderFns }